export enum ENUM_API_URL {
  BASKET_TYPE_URL = '/api/basketType/',
  CONTRACT_UPDATE_URL = '/api/contract/update/',
}

export enum ENUM_BASKET_TYPE_ENDPOINT {
  UPDATE_BASKET_PRODUCT = 'updateBasketProduct',
  ADD_BASKET_PRODUCT = 'addBasketProduct',
}
